import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BCMCLPUser, TeamCodes } from '../../models/clpuser.model';
import { UtilityService } from '../../services/shared/utility.service';
import { LocalService } from '../../services/shared/local.service';
import { GlobalService } from '../../services/shared/global.service';
import { Title } from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TeamOfficeService } from '../../services/team-office.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { SessionService } from '../../services/shared/session.service';

@Component({
    selector: 'app-cm-dashboard',
    templateUrl: './cm-dashboard.component.html',
    styleUrl: './cm-dashboard.component.css'
})
export class CmDashboardComponent {
    encryptedUser: string = '';
    user: BCMCLPUser;
    selectedCtDtFilter: number = 2;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string = '';
    selectedCustomdtEnd: string = '';
    customFilter: boolean = false;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};

    private destroy$ = new Subject<void>();

    constructor(
        private _router: Router,
        private _localService: LocalService,
        private _globalService: GlobalService,
        private titleService: Title,
        private _utilityService: UtilityService,
        private datePipe: DatePipe,
        private _teamOfficeService: TeamOfficeService,
        private _sessionService: SessionService
    ) {
        this.titleService.setTitle('Club Manager');
    }

    async ngOnInit() {
        this._localService.setShowMenu(true)
        this._localService.setIsCmManager(true);
        this._localService.setRouteName("cm-dashboard")
        this._localService.updateTeamDD(true)

        this.encryptedUser = await this._sessionService.getSession();

        if (this.encryptedUser) {
            await this.authenticateR();
            if (this.user) {
                localStorage.setItem("token", this.encryptedUser)

                this.loadData();
            }
            else {
                this._router.navigate(['/unauthorized']);
            }
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null)
                this.curTeam = data;
            else
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}");
        })
    }

    filterDashboard($event) {
        this.selectedCtDtFilter = $event;
        this.customFilter = ($event == 3);
    }

    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            this.selectedCustomdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
        }
        if (endDt) {
            this.selectedCustomdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCtDtFilter = 3;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.currentRange.reset();
        this.customFilter = false;
        this.selectedCtDtFilter = 2;
    }
}
